import { Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { useAuthContext } from "../../context/AuthContext";
import {
  BlueLinearGradient,
  showQuestionsAnnouncement,
  showTrailExpireAnnouncement,
  WhiteLinearGradient,
} from "../../utils/Utils";
import RequestCallDialog from "./RequestCallDialog";
import trainer_icon from "../../assets/icons/personal_trainer.png";
import CallCoachDialog from "./CallCoachDialog";

function Main({ children }) {
  const location = useLocation();
  const auth = useAuthContext();
  const [showCallCoachDialog, setShowCallCoachDialog] = useState(false);
  const appState = useAppContext();
  const noCallButtomLocation = [
    "/",
    "/profile",
    "/testimonials",
    "/refund-policy",
    "/faq",
    "/subscription",
    "/privacy",
    "/terms",
    "/disclaimer",
    "/register",
    "/science-behind-every-move",
  ];
  return (
    <main
      className={`${
        location.pathname == "/science-behind-every-move" ? "" : "pt-16"
      } relative flex flex-1  flex-col ${
        !auth.state.user ? "bg-primary-midBlack" : WhiteLinearGradient
      }`}
      // className={`pt-28 md:pt-20  bg-primary-midBlack realtive flex flex-1  flex-col`}
      style={{
        background:
          "linear-gradient(0deg, #222631, #222631),linear-gradient(0deg, #232D38, #232D38)",
      }}
    >
      {children}
      {/* <RequestCallDialog
        open={showCallCoachDialog}
        close={() => {
          setShowCallCoachDialog(false);
        }}
      /> */}
      <CallCoachDialog
        open={showCallCoachDialog}
        close={() => {
          setShowCallCoachDialog(false);
        }}
      />
      <Transition show={!noCallButtomLocation.includes(location.pathname)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-1000"
          enterFrom="opacity-0 scale-95"
          enterTo=" opacity-100 scale-1000"
          leave="ease-in duration-1000"
          leaveFrom=" opacity-100 scale-1000"
          leaveTo=" opacity-0 scale-95"
        >
          {/* <div
            className={`bg-[#5FEFDE] fixed rounded-full bottom-5 right-5 p-3 `}
            onClick={() => {
              setShowCallCoachDialog(true);
            }}
          >
            <Icon
              icon="ant-design:phone-outlined"
              color="#ffffff"
              className="w-6 md:w-10 h-auto  -scale-x-100"
            />
            <img
              src={trainer_icon}
              className="w-6 md:w-10 h-auto  -scale-x-100"
            />
          </div> */}
          <div></div>
        </Transition.Child>
      </Transition>
    </main>
  );
}

export default Main;
